var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutoOutletLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 56,
    viewBox: "0 0 140 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_24534",
    "data-name": "\\uC0AC\\uAC01\\uD615 24534",
    width: 119.992,
    height: 27.793,
    fill: "#38748f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_22288",
    "data-name": "\\uADF8\\uB8F9 22288",
    transform: "translate(-856 -3541)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_27426",
    "data-name": "\\uC0AC\\uAC01\\uD615 27426",
    width: 140,
    height: 56,
    rx: 8,
    transform: "translate(856 3541)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_22287",
    "data-name": "\\uADF8\\uB8F9 22287",
    transform: "translate(865.332 3554.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_14301",
    "data-name": "\\uADF8\\uB8F9 14301",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_14300",
    "data-name": "\\uADF8\\uB8F9 14300",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7306",
    "data-name": "\\uD328\\uC2A4 7306",
    d: "M64.641,19.415h3.938l1.869-5.642a1.857,1.857,0,0,0-1.763-2.44H55.729a1.124,1.124,0,0,1,.66,1.362q0,.142-2.2,6.72h3.947l.879-2.68h6.508Zm1.432-4.349h-6.5l.326-1a1.484,1.484,0,0,1,1.412-1.024h4.659a.556.556,0,0,1,.528.731Z",
    transform: "translate(-7.087 -1.482)",
    fill: "#38748f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7307",
    "data-name": "\\uD328\\uC2A4 7307",
    d: "M81.644,17.7h-5.2l1.468-4.418a1.485,1.485,0,0,0-1.41-1.951H73.428a.964.964,0,0,1,.746,1.337l-2.23,6.745H85.2l-1.357-1a3.709,3.709,0,0,0-2.195-.718",
    transform: "translate(-9.408 -1.482)",
    fill: "#38748f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7308",
    "data-name": "\\uD328\\uC2A4 7308",
    d: "M115.433,11.334s1.125.455.808,1.4l-1.209,3.649a1.854,1.854,0,0,1-1.762,1.273H109.9a.559.559,0,0,1-.53-.733l1.2-3.641a1.484,1.484,0,0,0-1.409-1.951h-3.132a1.09,1.09,0,0,1,.755,1.37l-1.537,4.762a1.486,1.486,0,0,0,1.413,1.954l1.884,0h6.74a3.714,3.714,0,0,0,3.532-2.564L120,13.287a1.484,1.484,0,0,0-1.409-1.953Z",
    transform: "translate(-13.754 -1.482)",
    fill: "#38748f"
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_4",
    "data-name": "\\uC120 4",
    x2: 0.002,
    y2: 0.001,
    transform: "translate(100.943 15.044)",
    fill: "#38748f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7309",
    "data-name": "\\uD328\\uC2A4 7309",
    d: "M102.481,11.334H91.564a3.339,3.339,0,0,0-3.172,2.293l-1.269,3.845a1.484,1.484,0,0,0,1.411,1.951h12.641L102.294,16a1.114,1.114,0,0,0-1.057-1.46H96.655a3.713,3.713,0,0,0-2.227.742l-1.238.927h5.092l-.447,1.361-6.027,0a.556.556,0,0,1-.528-.732l.894-2.689a1.484,1.484,0,0,1,1.409-1.018h5.252a3.717,3.717,0,0,0,2.22-.736Z",
    transform: "translate(-11.383 -1.482)",
    fill: "#38748f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7310",
    "data-name": "\\uD328\\uC2A4 7310",
    d: "M40.436,11.334H53.747v.043a5.553,5.553,0,0,1-4.184,1.67l-2.1,6.368H43.522l2.1-6.368a7.077,7.077,0,0,1-5.181-1.67Z",
    transform: "translate(-5.288 -1.482)",
    fill: "#38748f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7311",
    "data-name": "\\uD328\\uC2A4 7311",
    d: "M136.041,11.334H122.73v.043a5.549,5.549,0,0,0,4.183,1.67h.1l-2.1,6.368h3.942l2.1-6.368h-.1a7.084,7.084,0,0,0,5.184-1.67Z",
    transform: "translate(-16.05 -1.482)",
    fill: "#38748f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7312",
    "data-name": "\\uD328\\uC2A4 7312",
    d: "M24.638,5.089,22.352,8.078a10.357,10.357,0,1,1-2.335-2.411l2.992-2.25a13.868,13.868,0,1,0,1.629,1.672",
    transform: "translate(0 0)",
    fill: "#38748f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7313",
    "data-name": "\\uD328\\uC2A4 7313",
    d: "M24.806,4.16l-2.95,2.219L9.811,15.437H17.35L23.208,7.78l2.256-2.948,2.1-2.748Z",
    transform: "translate(-1.283 -0.273)",
    fill: "#ff6a13"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoOutletLogo);
export default __webpack_public_path__ + "static/media/AutoOutletLogo.76755733a71fc94a31a79f474afaee95.svg";
export { ForwardRef as ReactComponent };